import Prompt from ".";

export default function PromptExamples() {
  return <Prompt onAccept={() => {}} onDecline={() => {}} />;
}
